import React, { useEffect, useState } from 'react';
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from '../../../../firebase';
import PropertyForm from '../../../forms/property/property-form';
import StatesCities from "../../../../assets/json/states-and-districts.json";
import { useAuth } from '../../../../context/AuthContext';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

function EditProperty({ items, editPropertyModalShow, handleEditPropertyModalClose }) {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [stateCities, setStateCities] = useState(null);
  const [propertyData, setPropertyData] = useState(null);
  const [inputError, setInputError] = useState(null);

  function getStateCities(state) {
    const filteredCitiesByState = StatesCities && StatesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      setStateCities(filteredCitiesByState);
    }
  }

  useEffect(() => {
    if (items && items) {
      setPropertyData(items);
      getStateCities(items.state);
    }
  }, [items]);

  async function updateData(id, data) {
    setIsLoading(true);
    data = { ...data, addedOn: new Date(data.addedOn.seconds * 1000), updatedOn: new Date() };
    try {
      await updateDoc(doc(db, "Businesses", bid, "Properties", id), data);
      setIsLoading(false);
      handleEditPropertyModalClose();
    } catch (error) {
      console.log('Updating Property Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  function validateAndPostData() {
    const { name, locality, city, state } = propertyData;
    if (!name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else if (!locality) {
      setInputError({ ...inputError, locality: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else if (!city) {
      setInputError({ ...inputError, city: 'This field is required.' });
    } else {
      updateData(propertyData.id, propertyData);
    }
  }

  return (
    <Modal
      size='lg'
      show={editPropertyModalShow}
      onHide={handleEditPropertyModalClose}
      backdrop="static"
      keyboard={false}
      centered={true}
    >
      <div className='modal-header'>
        <h5 className='mb-0'>Edit Property</h5>
        <Button variant='none' className='btn-close px-3' onClick={handleEditPropertyModalClose} />
      </div>
      <div className='modal-body p-0'>
        <div className='px-4'>
          <PropertyForm
            propertyData={propertyData}
            setPropertyData={setPropertyData}
            stateCities={stateCities}
            getStateCities={getStateCities}
            inputError={inputError}
            setInputError={setInputError}
          />
        </div>
      </div>
      <div className='modal-footer px-3 align-items-center justify-content-between'>
        <Button
          variant="outline-danger"
          onClick={() => handleEditPropertyModalClose()}
          className='px-5 py-2'
        >
          Cancel
        </Button>
        {
          isLoading ?
            <Button
              disabled
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => null}
            >
              <div className='px-3 d-flex align-items-center'>
                <Spinner size='sm' />
                <span className='ms-2'>Updating...</span>
              </div>
            </Button>
            :
            <Button
              variant="primary"
              className='px-5 py-2 btn-width'
              onClick={() => validateAndPostData()}
            >
              Update
            </Button>
        }
      </div>
    </Modal>
  );
}

export default EditProperty;